import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Card, CardBody, Col, Container, Form, Input, Label, Row, Spinner } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
const EditNatureLicence = props => {
  const [nameFr, setNameFr] = useState("")
  const [nameAr, setNameAr] = useState("")
  const [loading, setLoading] = useState(false)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    if(nameAr === ""){
      toast.error("⛔ Nom AR obligatoire", {
        containerId: "A",
      })
    }else if(nameFr !== ""){
      API.post("gestion_master/nature_licence/store", {
        annee_id,
        name_fr:nameFr,
        name_ar:nameAr,
        user_id
      }).then(res => {
        toast.success(" 🔓✔️ Nature Licence Activé Avec succès", {
          containerId: "A",
        })
        props.setSection(1)
      })

    } else {
      toast.error("⛔ Nom FR obligatoire", {
        containerId: "A",
      })
    }
  }
  useEffect(async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]

    const res = await API.post("gestion_master/nature_licence/getbyid", { id }).then(res => {
      setNameAr(res.data.licence.name_ar)
      setNameFr(res.data.licence.name_fr)
      setLoading(true)
    })
  }, [])

  const edit = async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    if(nameAr === ""){
      toast.error("⛔ Nom AR obligatoire", {
        containerId: "A",
      })
    }else if(nameFr !== ""){
      API.post("gestion_master/nature_licence/edit", {
        id,
        annee_id,
        name_fr:nameFr,
        name_ar:nameAr,
        user_id
      }).then(res => {
        toast.success(" 🔓✔️ Nature Licence Activé Avec succès", {
          containerId: "A",
        })
        props.history.push("/GestionMastere/NatureLicence")
      })

    } else {
      toast.error("⛔ Nom FR obligatoire", {
        containerId: "A",
      })
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Card>
              <CardBody>
                {loading ? (
                  <AvForm>
                    <Form>
                      <Row >
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Nom nature licence Fr
                            </Label>
                            <Input
                              lg="3"
                              type="text"
                              className="form-control"
                              placeholder="Nom nature licence Fr"
                              required={true}
                              value={nameFr}
                              onChange={e => setNameFr(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Nom nature licence Ar
                            </Label>
                            <Input
                              lg="3"
                              type="text"
                              className="form-control"
                              placeholder="Nom nature licence Ar"
                              required={true}
                              value={nameAr}
                              onChange={e => setNameAr(e.target.value)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {" "}
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                          className="text-center mt-4"
                        >
                          <Button
                            type="button"
                            color="warning"
                            className="btn btn-warning  mb-2 me-2"
                            onClick={() => props.history.push("/Statut")}
                          >
                            {props.t("Annuler")}
                          </Button>
                        </div>
                      </Col>
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                          className="text-center mt-4"
                        >
                          <button
                            type="button"
                            className="btn btn-primary "
                            onClick={edit}
                          >
                            {props.t("Confirmer")}
                          </button>
                        </div>
                      </Col>
                    </div>
                  </AvForm>
                ) : (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      <Spinner type="grow" className="ms-6" color="primary" />
                    </div>
                    <h4
                      style={{ textAlign: "center", marginTop: "2%" }}
                      className="ms-6"
                    >
                      {" "}
                      {"Chargement"} ...{" "}
                    </h4>
                  </div>
                )}
              </CardBody>
            </Card>
          </Row>
          <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(EditNatureLicence)
EditNatureLicence.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
